import {
  SystemBannerAction,
  SystemBannerState,
  SYSTEM_BANNER_RESET,
  SYSTEM_BANNER_RESET_SYSTEM,
  SYSTEM_BANNER_RESET_PROPERTY,
  SYSTEM_BANNER_SET,
} from '../../actions/systemBanner/systemBannerActionType'

const initialState: SystemBannerState = {
  system: null,
  property: null,
}

export default (state: SystemBannerState = initialState, action: SystemBannerAction): SystemBannerState => {
  switch (action.type) {
    case SYSTEM_BANNER_SET:
      return {
        system: action.payload.system,
        property: action.payload.property,
      }
    case SYSTEM_BANNER_RESET:
      return initialState
    case SYSTEM_BANNER_RESET_SYSTEM:
      return { ...state, system: null }
    case SYSTEM_BANNER_RESET_PROPERTY:
      return { ...state, property: null }
    default:
      return state
  }
}
